import $ from 'jquery';

class BackgroundVideoController {
    constructor(elem) {
        this.elem = elem;
        this.target = elem.dataset.target;
        this.videoUrl = elem.dataset.video_url;
        this.mobileFallbackImage = elem.dataset.mobile_fall_backimage;
        this.useOnMobile = elem.dataset.use_on_mobile.toBoolean();

        this.applyBackgroundVideo();
    }

    applyBackgroundVideo() {
        const $webzoneWrapper = $(this.elem).closest('.webzone-wrapper');
        let backgroundWrapper = $(this.elem);

        switch (this.target) {
        case 'widget-zone':
            backgroundWrapper = $(this.elem).closest('.webzone-wrapper .row')[0]; // eslint-disable-line prefer-destructuring
            // need to give it an id
            $(backgroundWrapper).attr('id', `${this.elem.id}WidgetZone`);
            backgroundWrapper = `#${backgroundWrapper.id}`;
            break;
        case 'container':
            backgroundWrapper = `#${$webzoneWrapper[0].id}`;
            break;
        default:
            backgroundWrapper = `#${$webzoneWrapper[0].id}`;
            break;
        }

        const dataProperty = {
            videoURL: `${this.videoUrl}`,
            containment: `${backgroundWrapper}`,
            stopMovieOnBlur: false,
            autoPlay: true,
            mute: true,
            startAt: 0,
            loop: true,
            showControls: false,
            useOnMobile: this.useOnMobile,
            mobileFallbackImage: `${this.mobileFallbackImage}`,
            showYTLogo: false,
            realfullscreen: false,
            opacity: 1,
        };

        const videoElement = $(this.elem)[0];
        $(videoElement).data('property', dataProperty);
        $(this.elem).YTPlayer();
    }

    static init(container) {
        new BackgroundVideoController(container); // eslint-disable-line no-new
    }
}

window.BackgroundVideoController = BackgroundVideoController;
export default BackgroundVideoController;
